import React, { Component } from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";
import { findByFather, findElement } from "store/selectors/pageSelector";

import Button from "@alboompro/boom-components/general/button";
import Icon from "@alboompro/boom-components/general/icon";

import RangeInput from "editor/components/EditorElements/RangeInput";

import {
  CollapseWrapper,
  expandIcon,
  BorderedWrapper,
  BorderedItem
} from "editor/components/CollapseWrapper";
import { addColumn } from "store/actions/pageActions";

const FlexWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 5px 0 0 0;
  justify-content: ${props => props.justifyContent || "flex-start"};
  font-size: 14px;
  color: #252525;
`;

const TitleWrapper = styled.div`
  padding: 10px 0 10px 0;
`;

class ColumnsEditor extends Component {
  constructor(props) {
    super(props);
    const element = props.findElement(props.elementKey);
    const columns = props.findByFather(props.elementKey);

    // In case element was created without props, set as an
    // empty object.
    if (!element.props) {
      element.props = {};
    }

    this.state = {
      expanded: false,
      spacing: element.props.spacing || 20,
      columnsCount: columns.length
    };
  }

  addColumn = () => {
    if (this.canAddColumn()) {
      const { elementKey, addColumn } = this.props;
      let { columnsCount } = this.state;
      this.setState({ columnsCount: (columnsCount += 1) });
      addColumn(elementKey);
    }
  };

  canAddColumn = () => {
    const { elementKey, findByFather } = this.props;
    const columns = findByFather(elementKey);
    return columns.length < 12;
  };

  toggleExpand = () => {
    const { expanded } = this.state;
    this.setState({ expanded: !expanded });
  };

  handleSpacing = e => {
    const { updaterFn } = this.props;
    this.setState({ spacing: e.target.value }, () => {
      const { spacing } = this.state;
      updaterFn({ prop: "spacing", value: spacing });
    });
  };

  render() {
    const { expanded, spacing, columnsCount } = this.state;
    const canAdd = this.canAddColumn();

    return (
      <CollapseWrapper
        onChange={this.toggleExpand}
        expandIcon={expandIcon}
        expandIconPosition="right"
      >
        <FlexWrapper justifyContent="space-between">
          <TitleWrapper>Columns</TitleWrapper>
        </FlexWrapper>
        <BorderedWrapper>
          <BorderedItem style={{ marginBottom: 20 }}>
            <FlexWrapper justifyContent="space-between">
              <span>Spacing</span>
              <span>{spacing}</span>
            </FlexWrapper>
            <RangeInput
              min={0}
              max={30}
              step={5}
              value={spacing}
              onChange={this.handleSpacing}
            />
          </BorderedItem>
          <BorderedItem style={{ marginBottom: 15 }}>
            <FlexWrapper justifyContent="space-between">
              <span>Quantity</span>
              <span>{columnsCount}</span>
            </FlexWrapper>
          </BorderedItem>
        </BorderedWrapper>
        <Button
          disabled={!canAdd}
          style={{
            hegiht: "30px",
            margin: "5px auto 25px auto",
            borderRadius: "22px",
            outline: 0,
            backgroundColor: "#44adf8",
            height: "30px",
            padding: "0 20px"
          }}
          textStyle={{ fontSize: "12px", color: "#fff", fontWeight: 500 }}
          iconStyle={{ marginRight: "10px" }}
          icon={
            <Icon
              kind="bold"
              group="interface-essential"
              category="remove-add"
              file="add.svg"
              size="12"
              color="#ffffff"
            />
          }
          onClick={this.addColumn}
        >
          Add Column
        </Button>
      </CollapseWrapper>
    );
  }
}

const mapDispatchToProps = {
  addColumn
};

const mapStateToProps = state => ({
  findByFather: key => findByFather(state.page.components, key),
  findElement: key => findElement(state, key)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ColumnsEditor);
